<template>
  <div class="score-bg">
    <div class="container-fluid" style="height: 70%">
      <top-navigation></top-navigation>
      <table class="score-wrapper" style="width: 75%; margin-left: auto; margin-right: auto">
        <tr>
          <td width="30%" class="with-cursor text-right" @click="$router.push('/fact-cards')">
            <img src="../assets/img/fact-cards.png"/>
          </td>
          <td width="40%" class="align-middle score-text">
            <span class="score-subtitle">YOU SCORED</span><br/>
            <span class="score-title">{{ lastGameScore | numberWithCommas }}</span>
          </td>
          <td width="30%" class="with-cursor text-left" @click="$router.push('/fact-files')">
            <img src="../assets/img/fact-files.png"/>
          </td>
        </tr>
      </table>
    </div>
    <div class="container-fluid text-center" style="height: 15%">
      <button v-show="showNextLevelButton" @click="nextLevel()" class="btn ng-default-btn next-level">Next Level</button>
      <button v-show="!showNextLevelButton" @click="$router.push('/selection')" class="btn ng-default-btn next-level">Back To Games</button>
    </div>
    <div class="container-fluid score-bar" style="height: 15vh">
      <table>
        <tr>
          <td>
            <table class="game-score-btn">
              <tr>
                <td class="left" @click="$router.push('/fact-cards')">
                  <div>FACT CARDS</div>
                </td>
                <td class="left">
                  <div @click="$router.push('/fact-cards')"><img class="arrow" src="../assets/img/arrow-left.png"/></div>
                </td>
              </tr>
            </table>
          </td>
          <td class="middle-text">You’ve unlocked cool content!</td>
          <td>
            <table class="game-score-btn">
              <tr>
                <td class="right">
                  <div @click="$router.push('/fact-files')"><img class="arrow" src="../assets/img/arrow-right.png"/></div>
                </td>
                <td class="right" @click="$router.push('/fact-files')">
                  <div>FACT FILES</div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import TopNavigation from '../components/TopNavigation'

export default {
  name: 'GameScore',
  components: { TopNavigation },
  computed: {
    ...mapGetters(['score', 'diffTotalFoundFactCards', 'diffTotalFoundFactFiles', 'lastGameScore', 'hideAndSeekLevel'])
  },
  data () {
    return {
      showNextLevelButton: false
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.diffTotalFoundFactFiles > 0 || this.diffTotalFoundFactCards > 0) {
        this.$root.$emit('bv::show::popover')
      }
    }, 1000)
  },
  filters: {
    numberWithCommas (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    ...mapMutations(['toggleIsNextLevel', 'setCardDiff']),
    nextLevel () {
      this.setCardDiff()
      this.toggleIsNextLevel()
      this.$router.push('/hide-and-seek')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.path === '/hide-and-seek' && (vm.hideAndSeekLevel === 'medium' || vm.hideAndSeekLevel === 'hard')) {
        vm.showNextLevelButton = true
      }
    })
    next()
  }
}
</script>

<style scoped>
  .score-bg {
    width: 100%;
    height: 100%;
    background-image: url("../assets/img/true-or-false-score-bg.jpg");
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }

  .score-wrapper {
    width: 100%;
    height: 80%;

  }

  .score-text {
    position: relative;
    color: #000000;
    font-size: 2vw;
    text-align: center;
    font-family: "Geograph-Black";
    background-image: url("../assets/img/score-star.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .score-title {
    font-size: 4vw;
  }

  .score-bar {
    border-top: 2px #ffe290 solid;
    border-left: 2px #ffe290 solid;
    border-right: 1px #FFC509 solid;
    background: linear-gradient(135deg, rgba(255, 197, 9, 1) 0%, rgba(241, 134, 13, 1) 100%)
  }

  .score-bar table {
    width: 100%;
    height: 15vh;
    text-align: center;
  }

  .score-bar table td div {
    height: 15vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .score-bar .arrow {
    width: 12vh
  }

  .score-bar {
    height: 100%;
    font-family: "Geograph-Bold";
    font-size: 2vw;
  }

  .score-bar .middle-text {
    font-size: 2.2vw;
    text-align: center;
  }

  .arrow {
    cursor: default;
  }

  .game-score-btn {
  }

  .game-score-btn .left, .game-score-btn .right {
    color: #ffffff;
  }

  .game-score-btn, .game-score-btn img {
    cursor: pointer;
  }

  .game-score-btn:hover {
    filter: invert(100%);
  }

  .next-level {
    font-size: 3vh;
  }
  .score-wrapper img {
    width: 90%;
  }
</style>
